/**
 * Configures the generated OpenAPI singleton and re-exports the BFF service
 * classes so all application code imports from here, never from the generated
 * subtree directly.
 *
 * Token attachment: OpenAPI.TOKEN accepts an async resolver. The generated fetch
 * client calls it before each request and injects the result as
 * `Authorization: Bearer <token>`. The resolver (getBffToken) silently acquires
 * an MSAL token and redirects if interaction is required, covering the main
 * re-auth path.
 *
 * 401 re-auth: if the BFF returns HTTP 401 despite a valid token (e.g. a race
 * during token rotation), the generated client throws ApiError. Callers should
 * catch ApiError and handle 401 by invoking acquireTokenRedirect; the TOKEN
 * resolver already handles the more common interaction-required scenario.
 */
import { OpenAPI } from './generated/index.js';
import { API_BASE_URL } from '../config.js';
import { getBffToken } from './token.js';

OpenAPI.BASE = API_BASE_URL;
OpenAPI.WITH_CREDENTIALS = false;
OpenAPI.TOKEN = getBffToken;

// Re-export service classes — pages must import from here, not from generated/
export { AuditService } from './generated/index.js';
export { GaPriceService } from './generated/index.js';
export { IdentityService } from './generated/index.js';
export { OperationsService } from './generated/index.js';

// Re-export model types for use in component props / state
export type { GAPriceDto } from './generated/index.js';
export type { GAPriceSearchData } from './generated/index.js';
export type { ProductIdentification } from './generated/index.js';
export type { CustomerIdentification } from './generated/index.js';
export type { ImportAuditRow } from './generated/index.js';
export type { Principal } from './generated/index.js';
export { ApiError } from './generated/index.js';
